// Executive Alerts & Decisions
export const alertsData = {
  2024: [
    { type: "alert", text: { en: "Production below plan by 12%", pt: "Produção 12% abaixo do plano" }, severity: "high" },
    { type: "alert", text: { en: "CAPEX execution delayed in strategic project", pt: "Execução CAPEX atrasada em projecto estratégico" }, severity: "high" },
    { type: "alert", text: { en: "Cash headroom reduced vs prior quarter", pt: "Margem de caixa reduzida vs trimestre anterior" }, severity: "medium" },
  ],
  2025: [
    { type: "alert", text: { en: "CAPEX execution 13% below plan", pt: "Execução CAPEX 13% abaixo do plano" }, severity: "medium" },
    { type: "alert", text: { en: "Supply chain pressures on critical spares", pt: "Pressões na cadeia de abastecimento em peças críticas" }, severity: "medium" },
    { type: "alert", text: { en: "Regulatory inspection scheduled Q4", pt: "Inspecção regulatória agendada para Q4" }, severity: "low" },
  ],
  2026: [
    { type: "alert", text: { en: "Ore processing 5% below target", pt: "Processamento de minério 5% abaixo do objectivo" }, severity: "medium" },
    { type: "alert", text: { en: "Turnover rising in technical functions", pt: "Rotatividade a subir em funções técnicas" }, severity: "medium" },
    { type: "alert", text: { en: "Cash position under pressure from CAPEX timing", pt: "Posição de caixa pressionada pelo timing do CAPEX" }, severity: "high" },
  ],
};

export const decisionsData = {
  2024: [
    { text: { en: "CAPEX reprioritization between sustaining and growth", pt: "Repriorização de CAPEX entre manutenção e crescimento" } },
    { text: { en: "Mitigation plan for operational recovery", pt: "Plano de mitigação para recuperação operacional" } },
    { text: { en: "Retention measures approval for critical functions", pt: "Aprovação de medidas de retenção para funções críticas" } },
  ],
  2025: [
    { text: { en: "Accelerate Phase 2 expansion timeline", pt: "Acelerar cronograma de expansão Fase 2" } },
    { text: { en: "Review dividend policy given strong cash generation", pt: "Rever política de dividendos dado forte geração de caixa" } },
    { text: { en: "Approve new equipment acquisition program", pt: "Aprovar programa de aquisição de novo equipamento" } },
  ],
  2026: [
    { text: { en: "Strategic review of ore body development priorities", pt: "Revisão estratégica de prioridades de desenvolvimento" } },
    { text: { en: "Talent retention program for technical specialists", pt: "Programa de retenção de talento para especialistas técnicos" } },
    { text: { en: "Capital allocation decision for Q3-Q4", pt: "Decisão de alocação de capital para Q3-Q4" } },
  ],
};
